import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import axios from "axios";
import Loading from "../Loading";
import "./style.css";
import { CustomInput, Tooltip } from "reactstrap";

class ResourceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resource: [],
      fetchinprogress: false,
      tooltipOpen: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    axios
      .get(window.css_js_manager.ajax_url, {
        params: { action: "get_resources" }
      })
      .then(result => {
        this.setState({
          resource: result.data,
          fetchinprogress: true
        });
      });
  }

  deleteResource(id) {
    this.setState(
      {
        fetchinprogress: false
      },
      () => {
        axios
          .get(window.css_js_manager.ajax_url, {
            params: { action: "delete_resource", id: id }
          })
          .then(result => {
            this.setState({
              resource: result.data,
              fetchinprogress: true
            });
          });
      }
    );
  }

  toggleState(id, state) {
    this.setState(
      {
        fetchinprogress: false
      },
      () => {
        axios
          .get(window.css_js_manager.ajax_url, {
            params: { action: "toggle_state_resource", id: id, state: state }
          })
          .then(result => {
            this.setState({
              resource: result.data,
              fetchinprogress: true
            });
          });
      }
    );
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  list_item() {
    let list_items = this.state.resource.map(item => {
      let edit_link = "/addedit/" + item.id;
      return (
        <tr key={item.id}>
          <td>
            {item.url}
            {item.state !== undefined &&
              (item.state === 1 ? (
                <span className="ml-1 badge badge-success">Enabled</span>
              ) : (
                <span className="ml-1 badge badge-danger">Disabled</span>
              ))}
          </td>
          <td className="text-center align-middle">
            {item.state !== undefined ? (
              <CustomInput
                type="switch"
                id={"state_switch" + item.id}
                name="customSwitch"
                checked={item.state === 1 ? true : false}
                onChange={() => {
                  this.toggleState(item.id, item.state);
                }}
              />
            ) : (
              <CustomInput
                type="switch"
                name="customSwitch"
                id={"state_switch" + item.id}
                disabled
                checked="true"
                label="Buy PRO TO Disable"
              />
            )}
          </td>
          <td className="text-right">
            <button
              className="btn btn-sm btn-warning mr-1"
              onClick={() => {
                this.deleteResource(item.id);
              }}
            >
              Delete
            </button>
            <Link className="btn btn-sm btn-primary" to={edit_link}>
              Edit
            </Link>
          </td>
        </tr>
      );
    });
    return list_items;
  }

  render() {
    return (
      <React.Fragment>
        <table className="table table-hover">
          <thead className="thead-dark">
            <tr>
              <th className="list-url">Resource Url</th>
              <th className="text-center">
                <span id="info">Enable / Disable Rule</span>
                <Tooltip
                  placement="top"
                  target="info"
                  isOpen={this.state.tooltipOpen}
                  toggle={this.toggle}
                  autohide={false}
                >
                  This Feature is only available in the PRO version, using this
                  you can disable any rule without deleting it
                </Tooltip>
              </th>
              <th className="text-right">
                <Link className="btn btn-primary" to="/addedit/null">
                  Add New Resource
                </Link>
              </th>
            </tr>
          </thead>
          <tbody>{this.list_item()}</tbody>
        </table>
        {this.state.fetchinprogress === false && <Loading />}
      </React.Fragment>
    );
  }
}

export default ResourceList;
